import {Component, OnInit} from '@angular/core';
import {MetaTitle} from '../../../../decorator/meta-title';
import {BillingRequestService} from '../../../../services/accounting/billing-request.service';
import {BillingRequest} from '../../../../models/accounting/billing-request';
import {DatePipe, NgClass, NgForOf, NgIf} from '@angular/common';
import {CurrencyPipe} from '../../../../pipes/currency/currency.pipe';
import {Paginator} from '../../../../tools/pagination/paginator';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DateRangeSelectorComponent} from '../../../layout/date-range-selector/date-range-selector.component';
import {DateRange} from '../../../../types/date-range';
import {TranslatePipe} from '@ngx-translate/core';
import {DropdownSelectComponent} from '../../../layout/dropdown-select/dropdown-select.component';
import {DropdownSelectOptionComponent} from '../../../layout/dropdown-select-option/dropdown-select-option.component';
import {AuthService} from '../../../../services/auth/auth.service';
import {Config} from '../../../../models/config';
import {PaginatorComponent} from '../../../layout/paginator/paginator.component';
import {TableSorter} from '../../../../tools/table-sorter/table-sorter';

@Component({
  selector: 'app-payment-list',
  imports: [
    DatePipe,
    NgForOf,
    CurrencyPipe,
    DateRangeSelectorComponent,
    DateRangeSelectorComponent,
    DropdownSelectComponent,
    DropdownSelectOptionComponent,
    FormsModule,
    NgForOf,
    ReactiveFormsModule,
    TranslatePipe,
    PaginatorComponent,
    PaginatorComponent,
    NgClass,
    NgIf,
    TranslatePipe
  ],
  templateUrl: './payment-list.component.html',
  styleUrl: './payment-list.component.scss'
})
@MetaTitle('Payments')
export class PaymentListComponent implements OnInit {

  filters: FormGroup = new FormGroup({
    startingAt: new FormControl(),
    endingAt: new FormControl(),
    status: new FormControl([]),
    deferred: new FormControl('')
  });

  billingRequests: BillingRequest[] = [];
  invoiceStatusList: string[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('startingAt', 'desc');
  loaded: boolean = false;
  dateRangeInvalid: boolean = false;

  constructor(
    private readonly billingRequestService: BillingRequestService,
    private readonly auth: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.auth.getAsyncConfig().subscribe((config) => {
      if (config) {
        this.invoiceStatusList = config?.data?.invoiceStatusList ?? [];

        this.fetchAll();
      }
    });
  }

  fetchAll(): void {
    this.loaded = false;
    this.billingRequestService.findAll({}, this.paginator, this.tableSorter).subscribe((billingRequests: BillingRequest[]) => {
      this.billingRequests = billingRequests;

      this.loaded = true;
    });
  }

  updateRange(dateRange: DateRange): void {
    this.filters.get('startingAt')?.patchValue(dateRange.start);
    this.filters.get('endingAt')?.patchValue(dateRange.end);
  }

}
